import { getAnalytics, logEvent } from 'firebase/analytics';
import app from './firebase';

const analytics = getAnalytics(app);

export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  try {
    logEvent(analytics, eventName, eventParams);
  } catch (error) {
    console.error('Analytics error:', error);
  }
};

// Predefined events
export const AnalyticsEvents = {
  MESSAGE_SUBMIT: 'message_submit',
  RESEARCH_PAPER_CLICK: 'research_paper_click',
  GET_CREDITS_CLICK: 'get_credits_click',
  MODEL_SELECT: 'model_select',
  CHAT_RESET: 'chat_reset',
  CONSULTATION_COMPLETE: 'consultation_complete',
  CONSULTATION_ERROR: 'consultation_error',
  PROFILE_SELECTED: 'profile_selected',
  RESPONSE_LIKED: 'response_liked',
  RESPONSE_DISLIKED: 'response_disliked'
} as const;

// Event parameter types
export type EventParams = {
  message_length?: number;
  model_type?: 'mini' | 'pro';
  error_type?: string;
  credits_amount?: number;
  consultation_duration?: number;
  specialties_count?: number;
  profile_type?: 'patient' | 'professional';
  messageId?: string;
  conversationId?: string;
  hasFeedbackMessage?: boolean;
  feedbackRating?: 'like' | 'dislike';
}; 